import React, { Component } from "react";
import "./css/TRXContent.css";

class TRXContent extends Component {
    render() {
        return (
            <>
                <div className="content-wrapper">
                    <div className="title title-thin title-xl-2">
                        <h1>Stable and Fully-Backed</h1>
                    </div>
                    <div className="lead-s2 lead-light">
                        CHY is a 1:1 TRX-backed stablecoin, always convertible to exactly 1TRX at Charry.
                    </div>
                </div>
            </>
        );
    }
}

export default TRXContent;